import { useEffect, useContext, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useHistory } from 'react-router';

// import Topbar from '../../components/topbar/Topbar';
// import Sidebar from '../../components/sidebar/Sidebar';
// import Feed from '../../components/feed/Feed';
// import Rightbar from '../../components/rightbar/Rightbar';
import ActivateForm from './ActivateForm';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';

import './activate.css';
export default function Activate() {
  const { player } = useContext(AuthContext);
  const history = useHistory();

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useParams();
  const searchParams = new URLSearchParams(window.location.search || '');
  const idFromQuery = searchParams.get('id');

  const loggedInId = player?.data?.player?._id;

  useEffect(() => {
    // console.log('calling activateAccount');
    activateAccount();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const activateAccount = async () => {
    const targetId = idFromQuery || loggedInId || null;
    if (!targetId) {
      setError('You need to be logged in or open this link from your email.');
      setLoading(false);
      return;
    }
    try {
      //const tokenOg = token.replaceAll('JGJGEZ', '.');
      //alert(token, player.data.player._id);

      setLoading(true);
      // Check if the player is already verified (only if logged in)
      if (player?.data?.player?.verified) {
        setSuccess('Account is already verified.');
        setLoading(false);
        return;
      }

      const { data } = await axiosConn.post(
        'players/activateAccount',
        { token, id: targetId },
        {
          headers: {
            ...(player?.token ? { Authorization: `Bearer ${player.token}` } : {}),
          },
        },
      );
      // console.log(data);
      setSuccess(data.message);
      // alert(data?.message);
      //Cookies.set('player', JSON.stringify({ ...player, verified: true }));
      if (player?.data?.player) {
        player.data.player.verified = true;
        localStorage.setItem('player', JSON.stringify(player));
      }
      // history.push('/login');

      // dispatch({
      //   type: 'VERIFY',
      //   payload: true,
      // });

      // setTimeout(() => {
      //   //navigate('/');
      //   window.open('/login');
      // }, 1000);
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        'Activation failed. Please request a new link.';
      setError(msg);
      // alert(error.response.data.message);
      console.log(error);
      // setTimeout(() => {
      //   //navigate('/');
      //   console.log('already activated, redirect to /');
      //   window.open('/');
      // }, 1000);
    }
  };

  return (
    <>
      <div className="home">
        {success && (
          <ActivateForm
            type="success"
            header="Account verification succeeded."
            text={success}
            loading={loading}
          />
        )}
        {error && (
          <ActivateForm
            type="error"
            header="Account verification failed."
            text={error}
            loading={loading}
          />
        )}
      </div>
    </>
  );
}
